<template>
  <v-app>
    <Snackbar />
    <Navbar v-if="displayNavbar" />
    <NavDrawer v-if="displayNavDrawer" />

    <v-content>
      <router-view :key="$route.path"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import NavDrawer from './components/NavDrawer';
import Snackbar from './components/Snackbar';

export default {
  name: 'App',

  components: {
    Navbar,
    NavDrawer,
    Snackbar
  },

  data: () => ({
    //
  }),

  computed: {
    displayNavbar() {
      return this.$route.name !== 'Login' && this.$route.name !== 'notFound';
    },
    displayNavDrawer() {
      return this.$route.name !== 'Login' && this.$route.name !== 'notFound';
    }
  }
};
</script>
